import User from './User';

export default class Comment {
    createdTime: Date = new Date();

    createdBy: any;

    text = '';

    constructor(_text: string,
      _createdBy: any) {
      this.text = _text;
      this.createdBy = _createdBy;
    }
}
